import { createSlice } from "@reduxjs/toolkit";

export const facturaSlice = createSlice({
  name: "factura",
  initialState: [],
  reducers: {},
});

export default facturaSlice.reducer;
